import { render, staticRenderFns } from "./RevisionSolicitud.vue?vue&type=template&id=40c00546&scoped=true"
import script from "./RevisionSolicitud.vue?vue&type=script&lang=js"
export * from "./RevisionSolicitud.vue?vue&type=script&lang=js"
import style0 from "./RevisionSolicitud.vue?vue&type=style&index=0&id=40c00546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c00546",
  null
  
)

export default component.exports